// extracted by mini-css-extract-plugin
export var faq = "FAQ-module--faq--AN9S+";
export var faqInner = "FAQ-module--faqInner--4C1k5";